<template>
  <section class="w-full mt-8" aria-label="Müşteri Yorumları">
    <div class="max-w-7xl mx-auto">
      <div
        class="flex flex-row items-center justify-between px-4"
        aria-label="Müşteri Yorumları Başlık"
      >
        <div class="flex flex-row items-center gap-4">
          <div
            class="size-12 rounded bg-orange-500 flex items-center justify-center"
          >
            <Icon name="mdi:comment-account" class="text-white size-8" />
          </div>
          <h3 class="text-xl md:text-2xl font-bold">
            <span class="text-orange-500">Müşteri</span>
            <span class="text-black"> Yorumları </span>
          </h3>
        </div>
        <div class="flex flex-row items-center gap-4">
          <div
            @click="slidePrev"
            class="size-10 bg-orange-500 rounded flex items-center justify-center"
            aria-label="Önceki Yorum"
          >
            <Icon
              name="mingcute:right-line"
              class="rotate-180 text-white size-7"
            />
          </div>
          <div
            @click="slideNext"
            class="size-10 bg-orange-500 rounded flex items-center justify-center"
            aria-label="Sonraki Yorum"
          >
            <Icon name="mingcute:right-line" class="text-white size-7" />
          </div>
        </div>
      </div>
      <div
        class="landing-customer-comment-slider mt-8"
        aria-label="Müşteri Yorumları Slider"
      >
        <swiper
          ref="swiperRef"
          :loop="true"
          :modules="modules"
          :navigation="true"
          :space-between="10"
          :pagination="false"
          :draggable="true"
          :breakpoints="{
            '640': {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            '1024': {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }"
        >
          <swiper-slide
            v-for="(comment, index) in customerComments"
            aria-label="Müşteri Yorumları Slider Öğesi"
            :key="index"
            @swiper=""
          >
            <CustomerCommentItem
              :userName="comment.userName"
              :userTitle="comment.userTitle"
              :comment="comment.comment"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {
  A11y,
  Navigation,
  Pagination,
  Scrollbar,
  Virtual,
} from 'swiper/modules'
import CustomerCommentItem from './CustomerCommentItem.vue'

import { Swiper, SwiperSlide } from 'swiper/vue'

const modules = [Navigation, Pagination, Scrollbar, A11y, Virtual]

const customerComments = ref([
  {
    userName: 'Ceren Özkan',
    userTitle: 'Sosyal Medya Uzmanı',
    comment:
      'Önce tereddüt ettim ama gerçekten etkili oldu. Etkileşimler tamamen doğal görünüyor ve içeriklerim daha fazla keşfete düşüyor. 🚀',
  },
  {
    userName: 'Mert Şahin',
    userTitle: 'Dijital Pazarlama Danışmanı',
    comment:
      'Otomatik Etkileşim Aracı sayesinde sürekli takip etmeme gerek kalmadan hesabım aktif kalıyor. Kullanımı kolay ve zahmetsiz. 😊',
  },
  {
    userName: 'Okan Korkmaz',
    userTitle: 'E-Ticaret Girişimcisi',
    comment:
      'Mağaza sayesinde büyük hacimli işlemler yaptım, sonuçtan oldukça memnunum. İşlem süreci hızlı ve pratikti.',
  },
  {
    userName: 'Aslı Güneş',
    userTitle: 'Bireysel Kullanıcı',
    comment:
      '360Sosyal’in sunduğu hizmetler sayesinde markam sosyal medyada daha güçlü hale geldi. Doğru stratejiyle kullanıldığında etkileşimler organik olarak bile büyümeye devam ediyor. 💡',
  },
  {
    userName: 'İpek Demir',
    userTitle: 'Kurumsal Müşteri',
    comment:
      'Müşterilerimizin sosyal medya hesaplarını yönetirken sürekli manuel sipariş vermek zahmetliydi. 360Sosyal’in Otomatik Etkileşim Aracı sayesinde her şey otomatik ilerliyor, hesapları sürekli aktif tutabiliyoruz.',
  },
  {
    userName: 'Alp Eren',
    userTitle: 'İçerik Üreticisi',
    comment:
      'Deneme amaçlı kullandım, şimdi tüm siparişlerimi buradan veriyorum. Etkileşimler tamamen doğal ve hesap güvenliğim açısından da endişe duymuyorum.',
  },
  {
    userName: 'Emre Özdemir',
    userTitle: 'Teknoloji Meraklısı',
    comment:
      'Her siparişi manuel kontrol etmek zorunda kalmamak büyük kolaylık. Mağaza özelliği, daha büyük çaplı işlemler için iyi bir çözüm sunuyor.',
  },
  {
    userName: 'Duru Acar',
    userTitle: 'Serbest Çalışan (Freelancer)',
    comment:
      'Sürekli sipariş oluşturmak zorunda kalmadan, otomatik ilerleyen bir sistem harika. Böylece zaman kaybetmeden diğer işlerime odaklanabiliyorum. 🔥',
  },
  {
    userName: 'Kaan Doğan',
    userTitle: 'Girişimci',
    comment:
      'Ajans olarak birçok farklı sistem denedik fakat 360Sosyal’in sunduğu hizmetler, müşterilerimizin hesaplarını en sağlıklı şekilde büyütmemize yardımcı oldu.',
  },
  {
    userName: 'Oğuzhan Elmas',
    userTitle: 'Satış ve Pazarlama Uzmanı',
    comment:
      'Hızlı ve güvenilir bir sistem. Hesabımın sürekli aktif kalmasını sağlıyor ve algoritmaya uygun işleyişi sayesinde keşfedilirliğim artıyor.',
  },
  {
    userName: 'Melis Aksoy',
    userTitle: 'Küçük İşletme Sahibi',
    comment:
      'Daha önce benzer hizmetler kullandım ama hiçbiri bu kadar etkili olmamıştı. İçeriklerim daha fazla görünürlük kazandı. ⭐',
  },
  {
    userName: 'Furkan Demirtaş',
    userTitle: 'Reklam ve Tanıtım Danışmanı',
    comment:
      'Günlük onlarca müşteriye hizmet verirken her siparişi manuel takip etmek zor oluyordu. Otomatik etkileşim aracı ile artık işlemler otomatik ilerliyor ve tüm hesaplarımız düzenli etkileşim alıyor.',
  },
  {
    userName: 'Arda Yaman',
    userTitle: 'İnternet Girişimcisi',
    comment:
      'Gerçek kullanıcı etkileşimleri almak, sosyal medya hesaplarımı çok daha güçlü hale getirdi. Zaman içinde doğal büyüme sağladığını gözlemleyebiliyorum. 💯',
  },
  {
    userName: 'Burak Sönmez',
    userTitle: 'Dijital İçerik Üreticisi',
    comment:
      'Hesabımda sahte etkileşim istemiyordum. Burada tamamen gerçek kullanıcılarla büyüme sağladım ve içeriklerimin erişimi arttı. 📈',
  },
  {
    userName: 'Ege Türkmen',
    userTitle: 'Mobil Uygulama Kullanıcısı',
    comment:
      'Sosyal medya yönetimini yaptığımız firmaların hesaplarını Otomatik Etkileşim Aracı’na bağlıyoruz. İçerikler paylaşıldıkça etkileşimler otomatik geliyor. İçerikler doğru ve kaliteli kurgulandığında keşfete düşmesi muhtemel.',
  },
  {
    userName: 'Ece Yıldırım',
    userTitle: 'Sosyal Medya Yöneticisi',
    comment:
      'Otomatik Etkileşim Aracıyla belirlediğim aralıklarda düzenli olarak etkileşim alıyorum. Böylece içeriklerim sürekli görünür oluyor. 🔥',
  },
  {
    userName: 'Batuhan Öztürk',
    userTitle: 'Influencer Adayı',
    comment:
      'Markalarım için düzenli ve sürdürülebilir etkileşim sağlamanın bu kadar kolay olacağını tahmin etmiyordum. 360Sosyal, algoritmaya uygun etkileşim modeliyle hesapların doğal büyümesini destekliyor.',
  },
  {
    userName: 'Onur Bayraktar',
    userTitle: 'Marka Sahibi',
    comment:
      'Manuel sipariş özelliği sayesinde içeriklerime özel olarak destek verebiliyorum. Anlık müdahale edebilmek büyük avantaj sağlıyor.',
  },
  {
    userName: 'Selin Kurt',
    userTitle: 'Yeni İş Kurmuş Girişimci',
    comment:
      'Sürekli etkileşim almak, algoritmanın içeriğimi daha fazla kişiye ulaştırmasını sağladı. Gerçek büyüme sağlamak isteyenler için harika bir çözüm. 💡',
  },
  {
    userName: 'Kerem Tuncer',
    userTitle: 'Küçük İşletme Destekçisi',
    comment:
      'Uzun zamandır böyle kaliteli bir hizmet arıyordum. Gerçek kullanıcılarla etkileşim sağlamak gerçekten fark yaratıyor. 👏',
  },
  {
    userName: 'Nehir Çelik',
    userTitle: 'Online Mağaza Sahibi',
    comment:
      'Otomatik Etkileşim Aracı, içeriğimin performansını artırmak için harika bir sistem. Sürekli takip etmek zorunda kalmadan düzenli büyüme sağlıyorum.',
  },
  {
    userName: 'Baran Karaca',
    userTitle: 'Profesyonel Kullanıcı',
    comment:
      'Mağaza bölümündeki yüksek limitler sayesinde geniş çaplı kampanyalarımı rahatça yönettim. Büyük hacimli siparişler için oldukça kullanışlı. 🔝',
  },
  {
    userName: 'Emirhan Keskin',
    userTitle: 'Hizmet Sektörü Çalışanı',
    comment:
      'Diğer platformlarda aldığım hizmetler kısa sürede düşüş yaşıyordu. Burada ise uzun süreli ve dengeli bir etkileşim sağlandı. 👍',
  },
  {
    userName: 'Yiğit Çakır',
    userTitle: 'E-Ticaret Müşterisi',
    comment:
      'Sosyal medya hesaplarımı büyütmek için en iyi çözüm diyebilirim. Düzenli etkileşim almak, görünürlüğü ciddi şekilde artırdı. 🚀',
  },
  {
    userName: 'Taner Uslu',
    userTitle: 'Teknoloji Tutkunu',
    comment:
      'Sosyal medya platformlarının algoritmasına uygun bir şekilde çalışıyor. Bu yüzden etkileşimlerim kalıcı ve etkili oluyor.',
  },
  {
    userName: 'Elif Arslan',
    userTitle: 'Dijital Reklam Uzmanı',
    comment:
      'Sürekli sipariş vermek yerine Otomatik Etkileşim Aracı’nı kullanmak büyük kolaylık. Sistem kendiliğinden ilerliyor. 😊',
  },
  {
    userName: 'Cem İlhan',
    userTitle: 'Markalaşma Danışmanı',
    comment:
      'Mağaza, büyük hacimli işlemler için oldukça avantajlı. Yüksek limitlere ulaşabilmek için iyi bir seçenek sundu.',
  },
])

const slideNext = () => {
  const landingSliderElement = document.querySelector(
    '.landing-customer-comment-slider',
  )
  if (!landingSliderElement) return
  const nextBtn = landingSliderElement.querySelector('.swiper-button-next')
  nextBtn?.click()
}

const slidePrev = () => {
  const landingSliderElement = document.querySelector(
    '.landing-customer-comment-slider',
  )
  if (!landingSliderElement) return
  const prevBtn = landingSliderElement.querySelector('.swiper-button-prev')
  prevBtn?.click()
}

let timerSwiper: any

onMounted(() => {
  timerSwiper = setInterval(() => {
    slideNext()
  }, 5000)
})

onUnmounted(() => {
  if (timerSwiper) {
    clearInterval(timerSwiper)
  }
})
</script>

<style lang="scss">
.landing-customer-comment-slider {
  // .swiper-pagination {
  //   position: relative;
  //   top: 0px;
  //   .swiper-pagination-bullet-active {
  //     background-color: #f97316;
  //   }
  // }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
}
</style>
